export const GET_DEALER_ENGINE_PREVIEW_API_REQUEST = "GET_DEALER_ENGINE_PREVIEW_API_REQUEST";
export const GET_DEALER_ENGINE_PREVIEW_API_SUCCESS = "GET_DEALER_ENGINE_PREVIEW_API_SUCCESS";
export const GET_DEALER_ENGINE_PREVIEW_API_ERROR = "GET_DEALER_ENGINE_PREVIEW_API_ERROR";
